import { ga } from 'js/analytics/adapters'
export const trackSelectGender = () => {
  ga.track('select_gender')
}
